export const PAGE_TYPE = {
    ILENDING_HUB_UPLOAD: 'ilending_hub_upload',
    LIBERTY_MUTUAL_THANK_YOU: 'liberty_mutual_thank_you',
    ERROR: 'error_page',
};

export const PAGE_NAME = 'ilending_hub';